import { Image, UIHeading4 } from '@cian/ui-kit';
import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';
import { IStandardOffer } from '../../../../settings';

interface IOfferCardProps {
  offer: IStandardOffer;
  onClick(offer: IStandardOffer): void;
}

export function OfferCard({ offer, onClick }: IOfferCardProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['image']}>
        <Image objectFit="cover" width="100%" height="100%" preloader src={offer.thumbnailUrl} />
      </div>

      <div className={styles['content']}>
        <div className={styles['title']}>
          <UIHeading4 color="text-inverted-default">{offer.title}</UIHeading4>
        </div>
        <div className={styles['button']} onClick={() => onClick(offer)} data-testid="offer_card_button">
          <div className={styles['button-text']}>Подробнее</div>
          <div className={styles['button-icon']}>
            <IconActionArrowRight16 color="icon-inverted-default" />
          </div>
        </div>
      </div>
    </div>
  );
}
